import Vue from 'vue'
import App from './App.vue'

import PortalVue from 'portal-vue'

import * as nodes from '@/nodes';
import geofences from '@/geofences';

import KeenUI from 'keen-ui';
import 'keen-ui/dist/keen-ui.css';

import '@/components/nodes/nodes.less';
import { CrossesIntoGeometry, evaluateGeofence, Result } from './nodes';
import consoleModule from "@/console.js";

Vue.use(KeenUI);

Vue.use(PortalVue);

Vue.config.productionTip = false;

function createTestGeofences()
{
    let testRoot = new nodes.Root();

    let andNode = new nodes.Buffer();
    testRoot.add(andNode);

    andNode.add(new nodes.Geometry());
    andNode.add(new nodes.Geometry());

    geofences.addGeofence({
        name: "Test",
        kind: "regular",
        root: testRoot,
        template: null,
        testTemplateWith: null,
        group: "Default"
    });
}

window.bus = new Vue({
    data() {
        createTestGeofences();

        return {
            result: nodes.Result.empty,
            assets: {
                red: { key: "red", description: "Red", colour: "#ed553b", currentPosition: { x: 140, y: 140 }, previousPosition: { x: 140, y: 140 } },
                yellow: { key: "yellow", description: "Yellow", colour: "#fdd55c", currentPosition: { x: 260, y: 140 }, previousPosition: { x: 260, y: 140 } },
                green: { key: "green", description: "Green", colour: "#3caea3", currentPosition: { x: 260, y: 260 }, previousPosition: { x: 260, y: 260 } },
                blue: { key: "blue", description: "Blue", colour: "#20639b", currentPosition: { x: 140, y: 260 }, previousPosition: { x: 140, y: 260 } },
            },
            selectedGeofence: geofences.geofences[0],
            selectedNodeId: geofences.geofences[0].root.id,
            actionsState: {}
        };
    },
    watch: {
        selectedGeofence(newGeofence, oldGeofence) {
            this.selectedNodeId = newGeofence.root.id;
        }
    },
    created() {
        this.previousContext = null;
    },
    methods: {
        setPosition(key, x, y) {
            this.assets[key].currentPosition = { x, y };

            this.$emit("result-changed");
        },
        notifyGeofenceNodeChanged(geofence) {
            this.$emit("result-changed");
        },
        processActions(geofence, actions, asset) {
            for (let action of actions) {
                let flattened = action.grouping.flattened;
                let triggered = false;

                let stateKey = `${action.id}-${asset.key}`;

                let state = this.actionsState[stateKey];

                let levelAndAsset = flattened.levels && (flattened.assets == null || flattened.assets == Result.assetIncluded);

                let effective = {
                    geometries: null
                };

                if (flattened.geometries != null) {
                    effective.geometries = {
                        crossesIntoGeometry: flattened.geometries.crossesIntoGeometry && levelAndAsset,
                        crossesOutOfGeometry: flattened.geometries.crossesOutOfGeometry && levelAndAsset,
                        insideOfGeometry: flattened.geometries.insideOfGeometry && levelAndAsset,
                        outsideOfGeometry: flattened.geometries.outsideOfGeometry && levelAndAsset
                    };
                };

                if (state === undefined) {
                    state = {
                        insideOfGeometry: { value: false, changed: new Date(), triggered: false },
                        outsideOfGeometry: { value: false, changed: new Date(), triggered: false }
                    }

                    this.actionsState[stateKey] = state;
                }

                for (let [name, property] of Object.entries(state)) {
                    if (property.value != effective.geometries[name]) {
                        property.value = effective.geometries[name];
                        property.changed = new Date();
                        property.triggered = false;
                    }
                }

                let evaluateTriggered = (name, duration) => {
                    if (state[name].triggered || !state[name].value) return;

                    let elapsed = (new Date() - state[name].changed) / 1000;

                    if (elapsed > duration) {
                        state[name].triggered = true;

                        return true;
                    } else {
                        return false;
                    }
                };

                if (effective.geometries != null) {
                    switch (action.action.trigger) {
                        case 'crosses-into':
                            triggered = effective.geometries.crossesIntoGeometry;
                            break;

                        case 'crosses-out-of':
                            triggered = effective.geometries.crossesOutOfGeometry;
                            break;

                        case 'inside':
                            triggered = evaluateTriggered("insideOfGeometry", action.action.triggerDuration);
                            break;

                        case 'outside':
                            triggered = evaluateTriggered("outsideOfGeometry", action.action.triggerDuration);
                            break;
                    }
                }

                if (triggered) {
                    consoleModule.lines.push({
                        colour: asset.colour,
                        ordinal: consoleModule.lines.length + 1,
                        left: geofence.name,
                        right: action.action.message
                    });
                }
            }
        },
        poll() {
            for (let asset of Object.values(this.assets)) {
                for (let geofence of geofences.regularGeofences) {
                    let context = evaluateGeofence(geofence, {
                            currentPosition: asset.currentPosition,
                            previousPosition: asset.previousPosition,
                            assetKey: asset.key
                        }, this.previousContext);

                    this.previousContext = context;

                    if (context.result.type == nodes.Result.groupingType) {
                        let actions = nodes.extractActions(context.result.value);

                        this.processActions(geofence, actions, asset);
                    }

                    if (context.resultsByNodeId.has(this.selectedNodeId)) {
                        this.result = context.resultsByNodeId.get(this.selectedNodeId);

                        this.$emit("result-changed");
                    } else {
                        this.result = nodes.Result.empty;

                        this.$emit("result-changed");
                    }
                }

                asset.previousPosition = asset.currentPosition;
            }
        }
    }
});

setInterval(() => window.bus.poll(), 500);

new Vue({
    render: function (h) { return h(App) },
}).$mount('#app')
